import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Event } from 'src/app/model/event';
import { Member } from 'src/app/model/member';
import { MemberService } from 'src/app/services/member.service';
import { Location } from '@angular/common';
import { forkJoin } from 'rxjs';
import { EventService } from '../services/event.service';

@Component({
  selector: 'event-report',
  templateUrl: 'event-report.html',
  styles: [

  ]
})

export class EventReportComponent implements OnInit {
  event: Event = null;
  author: Member;
  date: Date;

  ngOnInit(): void {
    this.getEvent();
  }

  constructor(
    private eventService: EventService,
    private memberService: MemberService,
    private route: ActivatedRoute,
    private location: Location
  ) { }
  
  getEvent(): void {
    // get event id from route
    const eventId = this.route.snapshot.paramMap.get("id");
    forkJoin([this.eventService.getEvents(), this.memberService.getMembers()]).subscribe(results => {
      // get event
      this.event = results[0].find(event => event.eventId === eventId);
      this.date = localStorage.getItem("eventDate") ? new Date(localStorage.getItem("eventDate")) : this.event.date;
      // get author
      if (this.event) {
        this.author = results[1].find(member => member.memberId === this.event.authorId);
      }
    });
  }
}
